<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="lawsService"
    [idKey]="'lawId'"
></base-index-page>